export default __webpack_public_path__ + "static/media/BRN.363b8b89.svg";